import {
  CUSTOMER_ACCESS_PURCHASE,
  CUSTOMER_ACCESS_VIEW,
} from "../../client/constants";

export default function showEarlyAccessBanner(productData, isMixAndMatch) {
  if (!isMixAndMatch) {
    return isEligibleEarlyAccessProduct(productData);
  }

  return (
    productData?.products?.length > 0 &&
    productData.products.every(isEligibleEarlyAccessProduct)
  );
}

function isEligibleEarlyAccessProduct(product) {
  return [CUSTOMER_ACCESS_VIEW, CUSTOMER_ACCESS_PURCHASE].includes(
    product?.earlyAccess?.customerAccess,
  );
}
